import type { ComponentProps } from 'react';
import { StatusPill } from '@/components/ui/StatusPill';
import { cx } from '@/cva.config';

interface StatusGroupProps {
  appStatus?: NonNullable<ComponentProps<typeof StatusPill>['status']>;
  className?: string;
  jobStatus: NonNullable<ComponentProps<typeof StatusPill>['status']>;
}

export const StatusGroup = ({
  appStatus,
  className,
  jobStatus,
}: StatusGroupProps) => (
  <div className={cx('flex flex-wrap items-start gap-1.5', className)}>
    <StatusPill kind="job" status={jobStatus} />
    {appStatus && (
      <>
        <span className="text-xs text-subtle">·</span>
        <StatusPill kind="app" status={appStatus} />
      </>
    )}
  </div>
);
